import request from '@/sheep/request';

// 自律项打卡记录参数值
export interface LimitCheckinRecordValues {
	id : number
	recordId ?: number
	fieldId ?: number
	fieldValue ?: string
	fieldName ?: string
	fieldKey ?: string
	unitName ?: string
	optionName ?: string
	createTime ?: any
}

// 创建自律项打卡记录参数值
export const createLimitCheckinRecordValues = async (data : Partial<LimitCheckinRecordValues>) => {
	return request({
		url: '/wish/limit-checkin-record-values/create',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '创建成功'
		},
	});
}

// 更新自律项打卡记录参数值
export const updateLimitCheckinRecordValues = async (data : Partial<LimitCheckinRecordValues>) => {
	return request({
		url: '/wish/limit-checkin-record-values/update',
		method: 'PUT',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '更新成功'
		},
	});
}

// 删除自律项打卡记录参数值
export const deleteLimitCheckinRecordValues = async (id : number) => {
	return request({
		url: '/wish/limit-checkin-record-values/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 批量删除自律项打卡记录参数值
export const deleteLimitCheckinRecordValuesList = async (ids : number[]) => {
	return request({
		url: '/wish/limit-checkin-record-values/delete-list',
		method: 'DELETE',
		params: { ids },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 获得自律项打卡记录参数值
export const getLimitCheckinRecordValues = async (id : number) => {
	return request({
		url: '/wish/limit-checkin-record-values/get',
		method: 'GET',
		params: { id },
		custom: {
			auth: true
		},
	});
}

// 获得自律项打卡记录参数值分页
export const getLimitCheckinRecordValuesPage = async (params : any) => {
	return request({
		url: '/wish/limit-checkin-record-values/page',
		method: 'GET',
		params,
		custom: {
			auth: true
		},
	});
}